Like = function(data) {
    var self = this;

    var props = [
        {name: 'name'},
        {name: 'username'},
        {name: 'avatar'}
    ];

    self.activeDataRelations = [
        {type: 'belongsTo', storeTarget: 'comments', key: 'comment_id', storage: 'comment'},
        {type: 'belongsTo', storeTarget: 'replies', key: 'reply_id', storage: 'reply'},
        {type: 'belongsTo', storeTarget: 'topics', key: 'conversation_id', storage: 'topic'},
        //{type: 'belongsTo', storeTarget: 'users', key: 'user_id', storage: 'user'}
    ];

    ActiveData.call( self, data); //javascript 'classes' workaround
    self.activeDataInit(self, data, props); //setup active data
};